import SunAccent from "@/components/feature/SunAccent";
import Breadcrumbs, { type BreadcrumbItem } from "@/components/feature/Breadcrumbs";
import type { StoryPost } from "@/mocks/stories";

interface StoryArticleHeroProps {
  story: StoryPost;
  breadcrumbs: BreadcrumbItem[];
}

export default function StoryArticleHero({ story, breadcrumbs }: StoryArticleHeroProps) {
  return (
    <section className="relative min-h-[70vh] flex flex-col justify-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={story.cover}
          width={1920}
          height={1080}
          alt={`${story.title} — cover image for this Rythugaru farmer story from ${story.village}`}
          title={`${story.title} - Rythugaru farmer story`}
          className="w-full h-full object-cover object-top"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/85"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-32 pb-12 md:pb-16">
        <Breadcrumbs
          items={breadcrumbs}
        />

        <div className="flex flex-wrap items-center gap-3 mb-5">
          <SunAccent circleClassName="w-9 h-9" iconClassName="text-lg" />
          <span className="bg-accent-500 text-background-50 text-[11px] font-semibold px-3 py-1.5 rounded-full whitespace-nowrap">
            {story.category}
          </span>
          <span className="text-xs text-background-200">
            {story.date} · {story.readTime}
          </span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl leading-[1.08] text-background-50 font-semibold max-w-4xl">
          {story.title}
        </h1>

        <div className="flex flex-wrap items-center gap-x-6 gap-y-3 mt-7">
          <span className="flex items-center gap-3">
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/15 text-accent-300">
              <i className="ri-user-voice-line text-lg"></i>
            </span>
            <span className="text-sm text-background-100">
              By <span className="font-semibold text-background-50">{story.author}</span>
            </span>
          </span>
          <span className="flex items-center gap-2 text-sm text-background-200">
            <i className="ri-map-pin-2-line text-accent-300"></i>
            {story.village}
          </span>
        </div>
      </div>
    </section>
  );
}